let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("W0knM")).then(() => parcelRequire('7PW51'));